export default __webpack_public_path__ + "e54f328f818fb85691a69e6a0974667f.svg";